import { Button, Tooltip } from 'antd';
import React, { ReactNode, useCallback } from 'react';
import { CgTrash } from 'react-icons/cg';
import { FaArrowDown, FaArrowUp, FaEdit, FaPlus } from 'react-icons/fa';
import './editComponent.less';
import { useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteModuleFromPage,
  deleteModuleFromConfigs,
  updateModuleIndex,
} from '../store/config';
import { RootState } from '../store/store';

interface Props {
  pageId: string;
  pagePath: string;
  pageComponents: string[];
  children: ReactNode;
  instance: string;
  index: string;
  setComponents?: any;
  allowOnlyEdit?: boolean;
  selectedInstance: string | null;
  setSelectedInstance: React.Dispatch<React.SetStateAction<string | null>>;
  moduleName: string;
  initialData: any;
  isEditAllowed?: boolean;
}

const EditComponent = ({
  pageId,
  pagePath,
  pageComponents,
  children,
  instance,
  index,
  setComponents,
  allowOnlyEdit = false,
  selectedInstance,
  setSelectedInstance,
  moduleName,
  initialData,
  isEditAllowed,
}: Props) => {
  const {
    config: { modulesConfigs },
  } = useSelector((data: RootState) => data.config);
  // const displayInline = ["FlightList", "PackageListView", "AttractionListView"].includes(moduleName);
  const moduleConfig = modulesConfigs[instance || moduleName];
  const brokenModule = !moduleName;

  const displayInline =
    moduleConfig?.set === 'FlightListSet2' ||
    moduleConfig?.set === 'PackageListViewSet3' ||
    moduleName === 'AttractionListView';
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const isEditMode = searchParams.get('editMode') === 'true' && isEditAllowed;

  const handleEditOpen = (data: {
    instance: string;
    pageId: string;
    moduleName: string;
    index: string;
  }) => {
    setSelectedInstance(data.instance);
    window.parent.postMessage(
      {
        type: 'EditModule',
        message: data,
      },
      '*'
    );
  };

  const moveModule = (data: {
    dragIndex: any;
    hoverIndex: any;
    pageId: string;
    pagePath: string;
  }) => {
    if (data.dragIndex < 0 || data.hoverIndex > pageComponents.length - 1) {
      return;
    }
    window.parent.postMessage(
      {
        type: 'UpdateWhiteLabelModulesIndexes',
        ...data,
      },
      '*'
    );
    dispatch(updateModuleIndex(data));
  };

  const handleDelete = (data: {
    instance: string;
    moduleName: string;
    pageId: string;
    pagePath: string;
  }) => {
    window.parent.postMessage(
      {
        type: 'DeleteWhiteLabelModulesFromPage',
        ...data,
      },
      '*'
    );

    dispatch(deleteModuleFromPage(data));
    // MAYBE ADD It?
    // dispatch(deleteModuleFromConfigs(data));
  };

  const handleAddModule = ({ i }: { i: number }) => {
    window.parent.postMessage(
      { type: 'AddModule', message: { index: i } },
      '*'
    );
  };

  const getEditModeClassName = () => {
    let name = ``;
    if (isEditMode) {
      name += ' ' + 'EDIT';
    }
    if (allowOnlyEdit) {
      name += ' ' + 'ONLY-EDIT';
    }
    if (selectedInstance === instance) {
      name += ' ' + 'EDIT-MODE-ON';
    }
    if (displayInline) {
      name += ' ' + 'INLINE-MODULES-GROUP-ITEM';
    }

    return name || undefined;
  };


  return (
    <div id={`${moduleName}-wrapper`} className={getEditModeClassName()}>
      {isEditMode && (
        <div className="EDIT-BUTTON">
          {!allowOnlyEdit && (
            <Button
              className="add-btn-top"
              icon={<FaPlus />}
              onClick={() => handleAddModule({ i: Number(index) })}
            >
              Add Module on Top
            </Button>
          )}

          <div className="edit-actions-wrapper">
            {!allowOnlyEdit && (
              <div className="arrows-wrapper">
                <FaArrowUp
                  className={`button ${Number(index) <= 0 ? 'disabled' : ''}`}
                  size={18}
                  onClick={() =>
                    moveModule({
                      pageId,
                      pagePath,
                      dragIndex: Number(index) - 1,
                      hoverIndex: Number(index),
                    })
                  }
                />
                <FaArrowDown
                  className={`button ${
                    Number(index) + 1 >= pageComponents.length ? 'disabled' : ''
                  }`}
                  size={18}
                  onClick={() =>
                    moveModule({
                      pageId,
                      pagePath,
                      dragIndex: Number(index),
                      hoverIndex: Number(index) + 1,
                    })
                  }
                />
              </div>
            )}

            {moduleName && (
              <div
                onClick={() => {
                  handleEditOpen({ instance, pageId, moduleName, index });
                }}
                className="edit"
              >
                <FaEdit size={18} className="button" />
              </div>
            )}

            {(!allowOnlyEdit || brokenModule) && (
              <div
                className="delete"
                onClick={() => {
                  handleDelete({ instance, pageId, moduleName, pagePath });
                }}
              >
                <CgTrash size={18} className="button" />
              </div>
            )}
          </div>

          {!allowOnlyEdit && (
            <Button
              className="add-btn-bottom"
              icon={<FaPlus />}
              onClick={() => handleAddModule({ i: Number(index) + 1 })}
            >
              Add Module on Bottom
            </Button>
          )}
        </div>
      )}
      {children}
    </div>
  );
};

export default EditComponent;
